// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ThemeOptions } from '@mui/material';

export const dark: ThemeOptions = {
  palette: {
    mode: 'dark',
    primary: { main: '#F2FF96' },
    secondary: { main: '#F9FFCB' },
  },
  typography: {
    allVariants: {
      fontFamily: "'Lato', sans-serif;",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        html, body, #root {
          display: flex;
          width: 100%;
          height: 100%;
          align-items: center;
          justify-content: center;
        }
      `,
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: 'h1' },
              style: { fontSize: '40px', fontWeight: 'bold', lineHeight: '48px' },
            },
            {
              props: { variant: 'h2' },
              style: { fontSize: '32px', fontWeight: 'medium', lineHeight: '32px' },
            },
            {
              props: { variant: 'h3' },
              style: { fontSize: '24px', fontWeight: 'bold', lineHeight: '30px' },
            },
            {
              props: { variant: 'h4' },
              style: { fontSize: '20px', fontWeight: 'bold', lineHeight: '26px' },
            },
            {
              props: { variant: 'h5' },
              style: { fontSize: '16px', fontWeight: 'semibold', lineHeight: '24px' },
            },
            {
              props: { variant: 'h6' },
              style: { fontSize: '16px', fontWeight: 'bold', lineHeight: '22px' },
            },
          ],
        },
      },
    },
  },
};
